//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InputNumber from './partials/inputNumber.vue'

export default {
    data() {
        return {
            price_min: "",
            price_max: "",
            prices: [
                { min: null, max: 500000, text: "Hasta $500.000" },
                { min: 500000, max: 1000000, text: "$500.000 a $1.000.000" },
                { min: 1000000, max: 5000000, text: "$1.000.000 a $5.000.000" },
                { min: 5000000, max: null, text: "Más de $5.000.000" },
            ]
        };
    },
    mounted() {
        if (this.value && this.type == "number") {
            var value = this.formatNumber(this.value.toLocaleString());
            document.getElementById(this.name).value = value;
        }
    },
    methods: {
        formatNumber(value) {
            value = value.replace(/[^0-9]+/g, "");
            value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            return value;
        },
        handleInput(e) {
            var value = e.target.value;
            if (value && this.type == "number") {
                value = this.formatNumber(value);
                document.getElementById(this.name).value = value;
                this.$emit("input", parseInt(value.replace(/\./g, "")));
            }
            else {
                this.$emit("input", value);
            }
            this.$emit("clearError");
        }
        // applyPrice(){
        //     var filter = {}
        //     if(this.price_min){
        //         filter.price_min = this.price_min
        //     }
        //     if(this.price_max){
        //         filter.price_max = this.price_max
        //     }else{
        //         delete this.query.price_max
        //     }
        //     console.log(this.query)
        //     this.$router.push({query: {...this.query, ...filter}})
        // }
    },
    components: { InputNumber }
}
